module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "words-analyzer"
  }, [(_vm.visibleDialog) ? _c('div', {
    staticClass: "dialog-holder",
    class: 'dialog-holder-' + _vm.visibleDialog
  }, [_c('div', {
    staticClass: "dialog mdl-card mdl-shadow--4dp "
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().dialog[_vm.visibleDialog].title))]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent",
    on: {
      "click": _vm.closeDialog
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])])]), _vm._v(" "), (_vm.visibleDialog == 'saveView') ? _c('div', [_c('SaveView', {
    attrs: {
      "contentType": "words-view",
      "data": _vm.saveableView
    },
    on: {
      "close": _vm.closeDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.visibleDialog == 'loadView') ? _c('div', [_c('LoadView', {
    attrs: {
      "contentType": "words-view"
    },
    on: {
      "close": _vm.closeDialog,
      "load": _vm.loadView
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.inputTable != null) ? _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "stat-head"
  }, [_c('div', {
    staticClass: "stat-title-bar"
  }, [_c('h4', [_vm._v(_vm._s(_vm.inputTable.title)), (_vm.inputTable.fileName) ? _c('span', [_vm._v("[" + _vm._s(_vm.i18n().filename + _vm.inputTable.fileName) + "]")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "export-buttons"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.saveCSV
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveCSV) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored",
    on: {
      "click": _vm.saveTSV
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("archive")]), _vm._v(" " + _vm._s(_vm.i18n().saveTSV) + "\n          ")]), _vm._v(" "), _c('LoadFileSmall', {
    on: {
      "file": function (file) { return _vm.$emit('file', file); }
    }
  }, [_vm._v(">")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "statTopBarHolder"
  }, [_c('TopBar', {
    attrs: {
      "query": _vm.query,
      "inputColumnNames": _vm.inputTable && _vm.inputTable.columnNames,
      "calculatedColumnNames": _vm.calculatedTable && _vm.calculatedTable.columnNames,
      "categories": _vm.categories,
      "filter": _vm.filter,
      "appliedFilter": _vm.appliedFilter,
      "enableFilter": _vm.enableFilter,
      "filterExpanded": _vm.filterExpanded,
      "tips": _vm.tips,
      "tipsExpanded": _vm.tipsExpanded
    },
    on: {
      "update:query": function($event) {
        _vm.query = $event
      },
      "update:filter": function($event) {
        _vm.filter = $event
      },
      "update:enableFilter": function($event) {
        _vm.enableFilter = $event
      },
      "update:filterExpanded": function($event) {
        _vm.filterExpanded = $event
      },
      "update:tipsExpanded": function($event) {
        _vm.tipsExpanded = $event
      },
      "showTip": _vm.showTip,
      "save": _vm.openSaveViewDialog,
      "load": _vm.openLoadViewDialog,
      "applyFilter": _vm.applyFilter,
      "updateFilter": _vm.updateFilter,
      "clearFilter": _vm.clearFilter
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "stat-lower"
  }, [_c('WordsLeftBar', {
    attrs: {
      "query": _vm.query,
      "filter": _vm.filter,
      "appliedFilter": _vm.appliedFilter,
      "inputColumnNames": _vm.inputTable && _vm.inputTable.columnNames,
      "calculatedColumnNames": _vm.calculatedTable && _vm.calculatedTable.columnNames,
      "categories": _vm.categories,
      "enableFilter": _vm.enableFilter
    },
    on: {
      "update:query": function($event) {
        _vm.query = $event
      },
      "update:filter": function($event) {
        _vm.filter = $event
      },
      "update:enableFilter": function($event) {
        _vm.enableFilter = $event
      },
      "save": _vm.openSaveViewDialog,
      "load": _vm.openLoadViewDialog,
      "applyFilter": _vm.applyFilter,
      "updateFilter": _vm.updateFilter,
      "clearFilter": _vm.clearFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stat-content"
  }, [(_vm.state == 'computing' || _vm.state == 'filtering') ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))]), _vm._v(" "), _c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate",
    attrs: {
      "id": "p2"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'done' && _vm.limitedVisibleTable.rows.length == 0) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n().empty))])]) : _vm._e(), _vm._v(" "), (_vm.state == 'failed' && _vm.limitedVisibleTable.rows.length == 0) ? _c('div', {
    staticClass: "loading-holder"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n().failed))])]) : _vm._e(), _vm._v(" "), (_vm.limitedVisibleTable && _vm.limitedVisibleTable.rows.length > 0) ? _c('div', {
    staticClass: "table-space"
  }, [_c('BigTable2', {
    attrs: {
      "table": _vm.limitedVisibleTable,
      "sortColumn": _vm.sortColumn,
      "sortAsc": _vm.sortAsc,
      "endInfo": _vm.tableEndInfo
    },
    on: {
      "toggleSort": _vm.toggleSort
    }
  })], 1) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.testEnvironment) ? _c('div', {
    staticClass: "testSettings"
  }, [_c('b', [_vm._v("Test Settings:")]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "maxRows"
    }
  }, [_vm._v("maxRows:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxVisibleRows),
      expression: "maxVisibleRows"
    }],
    attrs: {
      "type": "text",
      "id": "maxRows"
    },
    domProps: {
      "value": (_vm.maxVisibleRows)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxVisibleRows = $event.target.value
      }
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cf71407"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WordsAnalyzer.vue
// module id = 457
// module chunks = 0